import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.7945 7.79457C15.1873 7.40182 15.8138 7.40182 16.2066 7.79457C16.5993 8.17796 16.5993 8.81385 16.1972 9.2066C16.0102 9.40298 15.7484 9.49649 15.4959 9.49649C15.2434 9.49649 14.9909 9.40298 14.7945 9.2066C14.4018 8.81385 14.4018 8.18732 14.7945 7.79457Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.48434 11.6768C2.01987 13.1412 2.01987 15.5156 3.48434 16.9801L7.01987 20.5156C8.48434 21.9801 10.8587 21.9801 12.3232 20.5156L19.4496 13.3891C20.245 12.5938 20.6413 11.4835 20.5294 10.3644L20.1266 6.33611C19.9963 5.03374 18.9662 4.00363 17.6638 3.87339L13.6356 3.47057C12.5164 3.35865 11.4061 3.75499 10.6108 4.5503L3.48434 11.6768ZM4.545 15.9194C3.66632 15.0407 3.66632 13.6161 4.545 12.7374L11.6715 5.61096C12.1487 5.13377 12.8148 4.89597 13.4863 4.96312L17.5146 5.36595C18.1066 5.42514 18.5748 5.89338 18.634 6.48536L19.0368 10.5136C19.104 11.1851 18.8662 11.8513 18.389 12.3285L11.2625 19.455C10.3838 20.3336 8.95921 20.3336 8.08053 19.455L4.545 15.9194Z",
		fill: "currentColor"
	})]
});
export { SvgIconTag as ReactComponent };
